/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const createFeedDataSchema = z.object({
	id: z.string().uuid().nullable().optional(),
	imageId: z.string().uuid().nullable().optional(),
	campaignId: z.string().uuid(),
	organisationId: z.string().uuid(),
	title: z.string(),
	subtitle: z.string(),
	button: z.string(),
	location: z.string(),
	metaTitle: z.string(),
	metaDescription: z.string(),
	metaCallToAction: z.string(),
	metaPrimaryText: z.string(),
	meta: z.record(z.string(), z.unknown()).nullable().optional(),
})

export type CreateFeedDataSchema = z.infer<typeof createFeedDataSchema>
